import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import moment from 'moment';
import PropTypes from 'prop-types';
import EditIcon from '@material-ui/icons/Edit';
import VisibileIcon from '@material-ui/icons/Visibility';
import AddIcon from '@material-ui/icons/AddCircle';
import DeleteIcon from '@material-ui/icons/DeleteOutline';

 import { makeStyles } from '@material-ui/styles';
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Checkbox,
  Divider,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  colors,
  TextField
} from '@material-ui/core';

import { Label,  TableEditBar } from '../../../../components';

const useStyles = makeStyles(theme => ({
  root: {},
  filterButton: {
    marginRight: theme.spacing(2)
  },
  content: {
    padding: 0
  },
  inner: {
  //  minWidth: 1150
  },
  actions: {
    padding: theme.spacing(0, 1),
    justifyContent: 'flex-end'
  }
}));

const Results = props => {
  const { className, orders,page,rowsPerPage,onLocalsearch,onPagelimitchange, onPagechange, onEdit,onDelete,onAdd, ...rest } = props;

  const classes = useStyles();

  const [selectedOrders, setSelectedOrders] = useState([]);

  const handleSelectAll = event => {
    const selectedOrders = event.target.checked
      ? orders.map(order => order.id)
      : [];

    setSelectedOrders(selectedOrders);
  };
  const handleinputchange = (event) => {
    onLocalsearch(event.target.value)
  }
  const handleSelectOne = (event, id) => {
    const selectedIndex = selectedOrders.indexOf(id);
    let newSelectedOrders = [];

    if (selectedIndex === -1) {
      newSelectedOrders = newSelectedOrders.concat(selectedOrders, id);
    } else if (selectedIndex === 0) {
      newSelectedOrders = newSelectedOrders.concat(selectedOrders.slice(1));
    } else if (selectedIndex === selectedOrders.length - 1) {
      newSelectedOrders = newSelectedOrders.concat(selectedOrders.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelectedOrders = newSelectedOrders.concat(
        selectedOrders.slice(0, selectedIndex),
        selectedOrders.slice(selectedIndex + 1)
      );
    }

    setSelectedOrders(newSelectedOrders);
  };

  const handleChangePage = (event, page) => {
    onPagechange(page);
  };

  const handleChangeRowsPerPage = event => {
    onPagelimitchange(event.target.value);
  };

  const paymentStatusColors = {
    canceled: colors.grey[600],
    pending: colors.orange[600],
    positive: colors.green[600],
    negative: colors.red[600]
  };

  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
     
      <Card>
        <CardHeader
          
          title="Live Prices"
          action={
            <TextField 
            fullWidth
            variant='outlined'
            type='small'
            onChange={handleinputchange}
            placeholder='Search'
            margin='dense'/>
          }
        />
        <Divider />
        <CardContent className={classes.content}>
            <div className={classes.inner}>
              <Table>
                <TableHead>
                  <TableRow>
                    {/* <TableCell padding="checkbox">
                      <Checkbox
                        checked={selectedOrders.length === orders.length}
                        color="primary"
                        indeterminate={
                          selectedOrders.length > 0 &&
                          selectedOrders.length < orders.length
                        }
                        onChange={handleSelectAll}
                      />
                    </TableCell> */}
                    <TableCell>S no</TableCell>
                    <TableCell>Product Name</TableCell>
                    <TableCell>Range Start</TableCell>
                    <TableCell>Range End</TableCell>
                    <TableCell>Price Difference</TableCell>
                    <TableCell>Created At</TableCell>
                    <TableCell align="center">Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {orders
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                   .map((order,index) => (
                    <TableRow
                      key={order.id}
                      selected={selectedOrders.indexOf(order.id) !== -1}
                    >
                      {/* <TableCell padding="checkbox">
                        <Checkbox
                          checked={selectedOrders.indexOf(order.id) !== -1}
                          color="primary"
                          onChange={event => handleSelectOne(event, order.id)}
                          value={selectedOrders.indexOf(order.id) !== -1}
                        />
                      </TableCell> */}
                      <TableCell>
                      {(page * rowsPerPage)+(index+1)}
                        
                      </TableCell>

                      <TableCell>{order ? order.name : ""}</TableCell>
                      <TableCell>{(order.live_prices && order.live_prices[0] )&& order.live_prices[0].price_start}</TableCell>
                      <TableCell>{(order.live_prices && order.live_prices[0] )&& order.live_prices[0].price_end}</TableCell>
                      <TableCell>
                       {(order.live_prices && order.live_prices[0] ) && order.live_prices[0].price_difference ? <Label
                          color={paymentStatusColors[order.live_prices[0].price_difference > 0 ? 'positive' : 'negative']}
                          variant="outlined"
                        >
                          {order.live_prices[0].price_difference}
                        </Label> : 0}

                      </TableCell>
                      <TableCell>
                      {(order.live_prices && order.live_prices[0] ) && <Typography variant="body1">
                          {moment(order?.live_prices[0].price_date).format(
                            'DD MMM YYYY   hh:mm a'
                          )}
                        </Typography>}
                      </TableCell>
                     
                      <TableCell align="center">
                      <Button  variant="outlined" size="small" onClick={() =>onAdd(order)}>
                        Add price
                           </Button>
                      <Button  ><EditIcon onClick={() =>onEdit(order)}/>
                           </Button>
                           <Button  ><DeleteIcon onClick={() =>onDelete(order)}/>
                           </Button>
                           <Button  component={RouterLink}
                         to={`/livesummary/${order.id}`} ><VisibileIcon />
                           </Button>
                           
                      </TableCell>
                      
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
        </CardContent>
        <CardActions className={classes.actions}>
          <TablePagination
            component="div"
            count={props.totalCount}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
            page={page}
            rowsPerPage={rowsPerPage}
            rowsPerPageOptions={[5, 10, 25,100]}
          />
        </CardActions>
      </Card>
      <TableEditBar selected={selectedOrders} />
    </div>
  );
};

Results.propTypes = {
  className: PropTypes.string,
  orders: PropTypes.array.isRequired,
  page: PropTypes.number,
  rowsPerPage: PropTypes.number,
  orders: PropTypes.array.isRequired,
  onPagechange: PropTypes.func,
  onPagelimitchange: PropTypes.func,
  onAdd : PropTypes.func,
  onEdit : PropTypes.func,
  onDelete : PropTypes.func
};

Results.defaultProps = {
  orders: []
};

export default Results;
